import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import localeIt from '@angular/common/locales/it';
import localeGb from '@angular/common/locales/en-GB';
import { SpinnerModule } from './shared/components/spinner/spinner.module';
import { registerLocaleData } from '@angular/common';
import { DynTableModule } from './shared/components/dyn-table';

registerLocaleData(localeIt);
registerLocaleData(localeGb);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule.forRoot(),
    SpinnerModule.forRoot({
      spinnerText: '',
      bgColor: 'rgba(0, 0, 0, 0.4)',
      size: 'large',
      color: '#040303',
      type: 'ball-clip-rotate',
      fullScreen: false
    }),
    DynTableModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: "it-IT"}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
